import create from "zustand";
import { produce } from "immer";

const STORE = {
  deviceInfo: null,
  theme: null,
  fileProgress: {}
};

const createWithImmer = (storeCreator) =>
  create((originalSet, originalGet) =>
    storeCreator((fn) => originalSet(produce(fn)), originalGet)
  );

export const usePWAStore = createWithImmer((setState, getState) => ({
  ...STORE,
  setDeviceInfo: (data) => {
    setState(() => {
      return {
        deviceInfo: data
      };
    });
  },
  getDeviceInfo: () => {
    let deviceInfo = getState().deviceInfo;
    return deviceInfo;
  },
  addFile: (data) => {
    let fileProgress = getState().fileProgress;
    fileProgress = { ...fileProgress };
    fileProgress[data.file.key] = data;
    setState(() => {
      return {
        fileProgress: fileProgress
      };
    });
  },
  updateFile: (data) => {
    let fileProgress = getState().fileProgress;
    fileProgress = { ...fileProgress };
    fileProgress[data.file.key] = data;
    setState(() => {
      return {
        fileProgress: fileProgress
      };
    });
  },
  removeFile: (data) => {
    let fileProgress = getState().fileProgress;
    fileProgress = { ...fileProgress };
    Reflect.deleteProperty(fileProgress, data.file.key);
    setState(() => {
      return {
        fileProgress: fileProgress
      };
    });
  },
  reset: () => {
    setState(() => ({
      ...STORE
    }));
  }
}));
